<section class="banner-section" id="banner">
    <div class="container">
        <div class="banner-text">
            <h1>About</h1>
        </div>
    </div>
</section>
<section class="content-text">
    <div class="container">
        <p>
            We are in the field of Embedded Design Services from year 1996, We have rolled out many successful projects in different domains & Automotive is the preferred segment. Since 1996 the core objective of our R&D is the development of innovative products
            with cutting-edge technology to meet customer requirement using state-of- art facilities and technical expertise. We are in the business of designing various types of custom electronic products at affordable costs while delivering high quality
            of work.
        </p>
    </div>
</section>
<app-services></app-services>
<div class="section-divider">

</div>